import API from '../api';
import type {
  CreateSignerRequest,
  SignerDto,
  UpdateSignerRequest,
} from '@paladin-monorepo/common';

export const signersApi = {
  async list(): Promise<SignerDto[]> {
    return API.get<SignerDto[]>('/signers').then((res) => res.data);
  },

  async create(data: CreateSignerRequest): Promise<SignerDto> {
    return API.post<SignerDto>('/signers', data).then((res) => res.data);
  },

  async update(signerId: string, data: UpdateSignerRequest): Promise<SignerDto> {
    return API.patch<SignerDto>(`/signers/${signerId}`, data).then((res) => res.data);
  },

  async remove(signerId: string): Promise<{ success: boolean }> {
    return API.delete<{ success: boolean }>(`/signers/${signerId}`).then((res) => res.data);
  },
};
